// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1___6400dc403b691108ad5","cls2":"CollapsedActivityPreview-cls2__b6fe3ff30d0afe2e4fc9 CollapsedActivityPreview-cls1___6400dc403b691108ad5"};